import { render } from "./pb-form-rentree.vue?vue&type=template&id=1b22ba84"
import script from "./pb-form-rentree.vue?vue&type=script&lang=js"
export * from "./pb-form-rentree.vue?vue&type=script&lang=js"

import "./pb-form-rentree.vue?vue&type=style&index=0&id=1b22ba84&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__